import moment from 'moment'
interface TimeAgoProps {
  timestamp: string
}

export const TimeAgo: React.FC<TimeAgoProps> = ({ timestamp }) => {
  const timeAgo = () => {
    const timeDifference = moment().diff(moment(timestamp))
    const duration = moment.duration(timeDifference)

    if (duration.asMinutes() < 1) {
      return 'Beberapa detik yang lalu'
    } else if (duration.asHours() < 1) {
      const minutes = Math.floor(duration.asMinutes())
      return `${minutes} menit yang lalu`
    } else {
      const hours = Math.floor(duration.asHours())
      if (hours > 24) {
        return `${Math.floor(hours / 24)} hari yang lalu`
      }
      return `${hours} jam yang lalu`
    }
  }

  return <p className="mt-2 text-xs text-gray-400">{timeAgo()}</p>
}
